export function createPop(heading, message, timeout) {

    // Create overlay
    $('body').prepend(
        `
            <div class="js-overlay" style="z-index: 10000000; text-align: center; width: 100%; height: 100%; position: fixed; background-color: rgba(0,0,0,0.6)">
                <dialog class="modelBox" tabindex="-1" id="trap">
                    <button class="js-close-model__btn close-btn" aria-label="Close"><i class="fas fa-times"></i></button>
                    <section style="border-bottom: 5px solid #e0e0e0;">
                        <div class="js-model-header modelHeader">
                            <h1>${heading}</h1>
                        </div>
                    </section>   
                    <section>
                        <div class="model-body">
                            <p>${message}</p>
                        </div>
                    </section>    
                </dialog>
            </div>
        `
    )

    $('body').on('click', '.js-close-model__btn', function(){
        $('.js-overlay').remove();
    });

    if (timeout) {
        setTimeout(function() { 
            $('.js-overlay').remove();
        }, timeout);
    }
}